import { FormattedDate, FormattedMessage } from 'react-intl';


export default function formatMessageWithDate(message, expirationDate) {

  const date = (
    <FormattedDate value={expirationDate}
                   month="short"
                   day="numeric" />
  );

  return (
    <FormattedMessage {...message}
                      values={{ date }} />
  );
}



// WEBPACK FOOTER //
// ./src/shared/utils/format-message-with-date.js